import { render, staticRenderFns } from "./UserReferralIncomesFilters.vue?vue&type=template&id=2fc56511&"
import script from "./UserReferralIncomesFilters.vue?vue&type=script&lang=js&"
export * from "./UserReferralIncomesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports